import { TAdFoxBannerTemplate } from '@cian/adfox-component';
import { AdFoxTemplates } from '@cian/adfox-templates';
import { Base64 } from 'js-base64';
import * as React from 'react';
import { MediaBannerContainer } from '../../MediaBanner';
import { useApplicationContext } from '../../../utils/applicationContext';
import { TMainpageBrandContext } from '../bannerTypes';

const OWN_BUNDLE_NAMES = ['banner.transfer'];
const OWN_TYPES: TAdFoxTemplatesParams['type'][] = ['mainpageBrand'];

export type TAdFoxTemplatesParams = TMainpageBrandContext;

export const OwnTemplates: React.FC<TAdFoxBannerTemplate> = props => {
  const { bundleName, bundleParams, containerId } = props;

  const { logger } = useApplicationContext();

  if (bundleName && OWN_BUNDLE_NAMES.includes(bundleName) && bundleParams) {
    if (bundleName === 'banner.transfer' && bundleParams.htmlBase64) {
      try {
        const decodedParams = Base64.decode(bundleParams.htmlBase64);
        const parsedDecodedParams = JSON.parse(decodedParams);

        if (isParsedParamsValid(parsedDecodedParams)) {
          if (OWN_TYPES.includes(parsedDecodedParams.type)) {
            switch (parsedDecodedParams.type) {
              case 'mainpageBrand':
                return <MediaBannerContainer context={parsedDecodedParams} containerId={containerId} />;
            }
          }
        }
      } catch (e) {
        logger.error(e, {
          message: '[AdFox] Failed to decode/parse bundleParams',
          bannerId: props.bundleParams?.bannerId,
        });
      }
    }
  }

  return <AdFoxTemplates {...props} deviceType="desktop" />;
};

function isParsedParamsValid(params: object): params is TAdFoxTemplatesParams {
  return 'type' in params;
}
